"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/** this is an auto-generated file from @react-md/dev-utils */
exports.default = {
    "rmd-red-50": "#ffebee",
    "rmd-red-100": "#ffcdd2",
    "rmd-red-200": "#ef9a9a",
    "rmd-red-300": "#e57373",
    "rmd-red-400": "#ef5350",
    "rmd-red-500": "#f44336",
    "rmd-red-600": "#e53935",
    "rmd-red-700": "#d32f2f",
    "rmd-red-800": "#c62828",
    "rmd-red-900": "#b71c1c",
    "rmd-red-a-100": "#ff8a80",
    "rmd-red-a-200": "#ff5252",
    "rmd-red-a-400": "#ff1744",
    "rmd-red-a-700": "#d50000",
    "rmd-pink-50": "#fce4ec",
    "rmd-pink-100": "#f8bbd0",
    "rmd-pink-200": "#f48fb1",
    "rmd-pink-300": "#f06292",
    "rmd-pink-400": "#ec407a",
    "rmd-pink-500": "#e91e63",
    "rmd-pink-600": "#d81b60",
    "rmd-pink-700": "#c2185b",
    "rmd-pink-800": "#ad1457",
    "rmd-pink-900": "#880e4f",
    "rmd-pink-a-100": "#ff80ab",
    "rmd-pink-a-200": "#ff4081",
    "rmd-pink-a-400": "#f50057",
    "rmd-pink-a-700": "#c51162",
    "rmd-purple-50": "#f3e5f5",
    "rmd-purple-100": "#e1bee7",
    "rmd-purple-200": "#ce93d8",
    "rmd-purple-300": "#ba68c8",
    "rmd-purple-400": "#ab47bc",
    "rmd-purple-500": "#9c27b0",
    "rmd-purple-600": "#8e24aa",
    "rmd-purple-700": "#7b1fa2",
    "rmd-purple-800": "#6a1b9a",
    "rmd-purple-900": "#4a148c",
    "rmd-purple-a-100": "#ea80fc",
    "rmd-purple-a-200": "#e040fb",
    "rmd-purple-a-400": "#d500f9",
    "rmd-purple-a-700": "#a0f",
    "rmd-deep-purple-50": "#ede7f6",
    "rmd-deep-purple-100": "#d1c4e9",
    "rmd-deep-purple-200": "#b39ddb",
    "rmd-deep-purple-300": "#9575cd",
    "rmd-deep-purple-400": "#7e57c2",
    "rmd-deep-purple-500": "#673ab7",
    "rmd-deep-purple-600": "#5e35b1",
    "rmd-deep-purple-700": "#512da8",
    "rmd-deep-purple-800": "#4527a0",
    "rmd-deep-purple-900": "#311b92",
    "rmd-deep-purple-a-100": "#b388ff",
    "rmd-deep-purple-a-200": "#7c4dff",
    "rmd-deep-purple-a-400": "#651fff",
    "rmd-deep-purple-a-700": "#6200ea",
    "rmd-indigo-50": "#e8eaf6",
    "rmd-indigo-100": "#c5cae9",
    "rmd-indigo-200": "#9fa8da",
    "rmd-indigo-300": "#7986cb",
    "rmd-indigo-400": "#5c6bc0",
    "rmd-indigo-500": "#3f51b5",
    "rmd-indigo-600": "#3949ab",
    "rmd-indigo-700": "#303f9f",
    "rmd-indigo-800": "#283593",
    "rmd-indigo-900": "#1a237e",
    "rmd-indigo-a-100": "#8c9eff",
    "rmd-indigo-a-200": "#536dfe",
    "rmd-indigo-a-400": "#3d5afe",
    "rmd-indigo-a-700": "#304ffe",
    "rmd-blue-50": "#e3f2fd",
    "rmd-blue-100": "#bbdefb",
    "rmd-blue-200": "#90caf9",
    "rmd-blue-300": "#64b5f6",
    "rmd-blue-400": "#42a5f5",
    "rmd-blue-500": "#2196f3",
    "rmd-blue-600": "#1e88e5",
    "rmd-blue-700": "#1976d2",
    "rmd-blue-800": "#1565c0",
    "rmd-blue-900": "#0d47a1",
    "rmd-blue-a-100": "#82b1ff",
    "rmd-blue-a-200": "#448aff",
    "rmd-blue-a-400": "#2979ff",
    "rmd-blue-a-700": "#2962ff",
    "rmd-light-blue-50": "#e1f5fe",
    "rmd-light-blue-100": "#b3e5fc",
    "rmd-light-blue-200": "#81d4fa",
    "rmd-light-blue-300": "#4fc3f7",
    "rmd-light-blue-400": "#29b6f6",
    "rmd-light-blue-500": "#03a9f4",
    "rmd-light-blue-600": "#039be5",
    "rmd-light-blue-700": "#0288d1",
    "rmd-light-blue-800": "#0277bd",
    "rmd-light-blue-900": "#01579b",
    "rmd-light-blue-a-100": "#80d8ff",
    "rmd-light-blue-a-200": "#40c4ff",
    "rmd-light-blue-a-400": "#00b0ff",
    "rmd-light-blue-a-700": "#0091ea",
    "rmd-cyan-50": "#e0f7fa",
    "rmd-cyan-100": "#b2ebf2",
    "rmd-cyan-200": "#80deea",
    "rmd-cyan-300": "#4dd0e1",
    "rmd-cyan-400": "#26c6da",
    "rmd-cyan-500": "#00bcd4",
    "rmd-cyan-600": "#00acc1",
    "rmd-cyan-700": "#0097a7",
    "rmd-cyan-800": "#00838f",
    "rmd-cyan-900": "#006064",
    "rmd-cyan-a-100": "#84ffff",
    "rmd-cyan-a-200": "#18ffff",
    "rmd-cyan-a-400": "#00e5ff",
    "rmd-cyan-a-700": "#00b8d4",
    "rmd-teal-50": "#e0f2f1",
    "rmd-teal-100": "#b2dfdb",
    "rmd-teal-200": "#80cbc4",
    "rmd-teal-300": "#4db6ac",
    "rmd-teal-400": "#26a69a",
    "rmd-teal-500": "#009688",
    "rmd-teal-600": "#00897b",
    "rmd-teal-700": "#00796b",
    "rmd-teal-800": "#00695c",
    "rmd-teal-900": "#004d40",
    "rmd-teal-a-100": "#a7ffeb",
    "rmd-teal-a-200": "#64ffda",
    "rmd-teal-a-400": "#1de9b6",
    "rmd-teal-a-700": "#00bfa5",
    "rmd-green-50": "#e8f5e9",
    "rmd-green-100": "#c8e6c9",
    "rmd-green-200": "#a5d6a7",
    "rmd-green-300": "#81c784",
    "rmd-green-400": "#66bb6a",
    "rmd-green-500": "#4caf50",
    "rmd-green-600": "#43a047",
    "rmd-green-700": "#388e3c",
    "rmd-green-800": "#2e7d32",
    "rmd-green-900": "#1b5e20",
    "rmd-green-a-100": "#b9f6ca",
    "rmd-green-a-200": "#69f0ae",
    "rmd-green-a-400": "#00e676",
    "rmd-green-a-700": "#00c853",
    "rmd-light-green-50": "#f1f8e9",
    "rmd-light-green-100": "#dcedc8",
    "rmd-light-green-200": "#c5e1a5",
    "rmd-light-green-300": "#aed581",
    "rmd-light-green-400": "#9ccc65",
    "rmd-light-green-500": "#8bc34a",
    "rmd-light-green-600": "#7cb342",
    "rmd-light-green-700": "#689f38",
    "rmd-light-green-800": "#558b2f",
    "rmd-light-green-900": "#33691e",
    "rmd-light-green-a-100": "#ccff90",
    "rmd-light-green-a-200": "#b2ff59",
    "rmd-light-green-a-400": "#76ff03",
    "rmd-light-green-a-700": "#64dd17",
    "rmd-lime-50": "#f9fbe7",
    "rmd-lime-100": "#f0f4c3",
    "rmd-lime-200": "#e6ee9c",
    "rmd-lime-300": "#dce775",
    "rmd-lime-400": "#d4e157",
    "rmd-lime-500": "#cddc39",
    "rmd-lime-600": "#c0ca33",
    "rmd-lime-700": "#afb42b",
    "rmd-lime-800": "#9e9d24",
    "rmd-lime-900": "#827717",
    "rmd-lime-a-100": "#f4ff81",
    "rmd-lime-a-200": "#eeff41",
    "rmd-lime-a-400": "#c6ff00",
    "rmd-lime-a-700": "#aeea00",
    "rmd-yellow-50": "#fffde7",
    "rmd-yellow-100": "#fff9c4",
    "rmd-yellow-200": "#fff59d",
    "rmd-yellow-300": "#fff176",
    "rmd-yellow-400": "#ffee58",
    "rmd-yellow-500": "#ffeb3b",
    "rmd-yellow-600": "#fdd835",
    "rmd-yellow-700": "#fbc02d",
    "rmd-yellow-800": "#f9a825",
    "rmd-yellow-900": "#f57f17",
    "rmd-yellow-a-100": "#ffff8d",
    "rmd-yellow-a-200": "#ff0",
    "rmd-yellow-a-400": "#ffea00",
    "rmd-yellow-a-700": "#ffd600",
    "rmd-amber-50": "#fff8e1",
    "rmd-amber-100": "#ffecb3",
    "rmd-amber-200": "#ffe082",
    "rmd-amber-300": "#ffd54f",
    "rmd-amber-400": "#ffca28",
    "rmd-amber-500": "#ffc107",
    "rmd-amber-600": "#ffb300",
    "rmd-amber-700": "#ffa000",
    "rmd-amber-800": "#ff8f00",
    "rmd-amber-900": "#ff6f00",
    "rmd-amber-a-100": "#ffe57f",
    "rmd-amber-a-200": "#ffd740",
    "rmd-amber-a-400": "#ffc400",
    "rmd-amber-a-700": "#ffab00",
    "rmd-orange-50": "#fff3e0",
    "rmd-orange-100": "#fff0b2",
    "rmd-orange-200": "#ffcc80",
    "rmd-orange-300": "#ffb74d",
    "rmd-orange-400": "#ffa726",
    "rmd-orange-500": "#ff9800",
    "rmd-orange-600": "#fb8c00",
    "rmd-orange-700": "#f57c00",
    "rmd-orange-800": "#ef6c00",
    "rmd-orange-900": "#e65100",
    "rmd-orange-a-100": "#ffd180",
    "rmd-orange-a-200": "#ffab40",
    "rmd-orange-a-400": "#ff9100",
    "rmd-orange-a-700": "#ff6d00",
    "rmd-deep-orange-50": "#fbe9e7",
    "rmd-deep-orange-100": "#ffccbc",
    "rmd-deep-orange-200": "#ffab91",
    "rmd-deep-orange-300": "#ff8a65",
    "rmd-deep-orange-400": "#ff7043",
    "rmd-deep-orange-500": "#ff5722",
    "rmd-deep-orange-600": "#f4511e",
    "rmd-deep-orange-700": "#e64a19",
    "rmd-deep-orange-800": "#d84315",
    "rmd-deep-orange-900": "#bf360c",
    "rmd-deep-orange-a-100": "#ff9e80",
    "rmd-deep-orange-a-200": "#ff6e40",
    "rmd-deep-orange-a-400": "#ff3d00",
    "rmd-deep-orange-a-700": "#dd2c00",
    "rmd-brown-50": "#efebe9",
    "rmd-brown-100": "#d7ccc8",
    "rmd-brown-200": "#bcaaa4",
    "rmd-brown-300": "#a1887f",
    "rmd-brown-400": "#8d6e63",
    "rmd-brown-500": "#795548",
    "rmd-brown-600": "#6d4c41",
    "rmd-brown-700": "#5d4037",
    "rmd-brown-800": "#4e342e",
    "rmd-brown-900": "#3e2723",
    "rmd-grey-50": "#fafafa",
    "rmd-grey-100": "#f5f5f5",
    "rmd-grey-200": "#eee",
    "rmd-grey-300": "#e0e0e0",
    "rmd-grey-400": "#bdbdbd",
    "rmd-grey-500": "#9e9e9e",
    "rmd-grey-600": "#757575",
    "rmd-grey-700": "#616161",
    "rmd-grey-800": "#424242",
    "rmd-grey-900": "#212121",
    "rmd-blue-grey-50": "#eceff1",
    "rmd-blue-grey-100": "#cfd8dc",
    "rmd-blue-grey-200": "#b0bec5",
    "rmd-blue-grey-300": "#90a4ae",
    "rmd-blue-grey-400": "#78909c",
    "rmd-blue-grey-500": "#607d8b",
    "rmd-blue-grey-600": "#546e7a",
    "rmd-blue-grey-700": "#455a64",
    "rmd-blue-grey-800": "#37474f",
    "rmd-blue-grey-900": "#263238",
    "rmd-black-base": "#000",
    "rmd-white-base": "#fff",
    "rmd-theme-color-map": {
        "rmd-red-50": "#ffebee",
        "rmd-red-100": "#ffcdd2",
        "rmd-red-200": "#ef9a9a",
        "rmd-red-300": "#e57373",
        "rmd-red-400": "#ef5350",
        "rmd-red-500": "#f44336",
        "rmd-red-600": "#e53935",
        "rmd-red-700": "#d32f2f",
        "rmd-red-800": "#c62828",
        "rmd-red-900": "#b71c1c",
        "rmd-red-a-100": "#ff8a80",
        "rmd-red-a-200": "#ff5252",
        "rmd-red-a-400": "#ff1744",
        "rmd-red-a-700": "#d50000",
        "rmd-pink-50": "#fce4ec",
        "rmd-pink-100": "#f8bbd0",
        "rmd-pink-200": "#f48fb1",
        "rmd-pink-300": "#f06292",
        "rmd-pink-400": "#ec407a",
        "rmd-pink-500": "#e91e63",
        "rmd-pink-600": "#d81b60",
        "rmd-pink-700": "#c2185b",
        "rmd-pink-800": "#ad1457",
        "rmd-pink-900": "#880e4f",
        "rmd-pink-a-100": "#ff80ab",
        "rmd-pink-a-200": "#ff4081",
        "rmd-pink-a-400": "#f50057",
        "rmd-pink-a-700": "#c51162",
        "rmd-purple-50": "#f3e5f5",
        "rmd-purple-100": "#e1bee7",
        "rmd-purple-200": "#ce93d8",
        "rmd-purple-300": "#ba68c8",
        "rmd-purple-400": "#ab47bc",
        "rmd-purple-500": "#9c27b0",
        "rmd-purple-600": "#8e24aa",
        "rmd-purple-700": "#7b1fa2",
        "rmd-purple-800": "#6a1b9a",
        "rmd-purple-900": "#4a148c",
        "rmd-purple-a-100": "#ea80fc",
        "rmd-purple-a-200": "#e040fb",
        "rmd-purple-a-400": "#d500f9",
        "rmd-purple-a-700": "#a0f",
        "rmd-deep-purple-50": "#ede7f6",
        "rmd-deep-purple-100": "#d1c4e9",
        "rmd-deep-purple-200": "#b39ddb",
        "rmd-deep-purple-300": "#9575cd",
        "rmd-deep-purple-400": "#7e57c2",
        "rmd-deep-purple-500": "#673ab7",
        "rmd-deep-purple-600": "#5e35b1",
        "rmd-deep-purple-700": "#512da8",
        "rmd-deep-purple-800": "#4527a0",
        "rmd-deep-purple-900": "#311b92",
        "rmd-deep-purple-a-100": "#b388ff",
        "rmd-deep-purple-a-200": "#7c4dff",
        "rmd-deep-purple-a-400": "#651fff",
        "rmd-deep-purple-a-700": "#6200ea",
        "rmd-indigo-50": "#e8eaf6",
        "rmd-indigo-100": "#c5cae9",
        "rmd-indigo-200": "#9fa8da",
        "rmd-indigo-300": "#7986cb",
        "rmd-indigo-400": "#5c6bc0",
        "rmd-indigo-500": "#3f51b5",
        "rmd-indigo-600": "#3949ab",
        "rmd-indigo-700": "#303f9f",
        "rmd-indigo-800": "#283593",
        "rmd-indigo-900": "#1a237e",
        "rmd-indigo-a-100": "#8c9eff",
        "rmd-indigo-a-200": "#536dfe",
        "rmd-indigo-a-400": "#3d5afe",
        "rmd-indigo-a-700": "#304ffe",
        "rmd-blue-50": "#e3f2fd",
        "rmd-blue-100": "#bbdefb",
        "rmd-blue-200": "#90caf9",
        "rmd-blue-300": "#64b5f6",
        "rmd-blue-400": "#42a5f5",
        "rmd-blue-500": "#2196f3",
        "rmd-blue-600": "#1e88e5",
        "rmd-blue-700": "#1976d2",
        "rmd-blue-800": "#1565c0",
        "rmd-blue-900": "#0d47a1",
        "rmd-blue-a-100": "#82b1ff",
        "rmd-blue-a-200": "#448aff",
        "rmd-blue-a-400": "#2979ff",
        "rmd-blue-a-700": "#2962ff",
        "rmd-light-blue-50": "#e1f5fe",
        "rmd-light-blue-100": "#b3e5fc",
        "rmd-light-blue-200": "#81d4fa",
        "rmd-light-blue-300": "#4fc3f7",
        "rmd-light-blue-400": "#29b6f6",
        "rmd-light-blue-500": "#03a9f4",
        "rmd-light-blue-600": "#039be5",
        "rmd-light-blue-700": "#0288d1",
        "rmd-light-blue-800": "#0277bd",
        "rmd-light-blue-900": "#01579b",
        "rmd-light-blue-a-100": "#80d8ff",
        "rmd-light-blue-a-200": "#40c4ff",
        "rmd-light-blue-a-400": "#00b0ff",
        "rmd-light-blue-a-700": "#0091ea",
        "rmd-cyan-50": "#e0f7fa",
        "rmd-cyan-100": "#b2ebf2",
        "rmd-cyan-200": "#80deea",
        "rmd-cyan-300": "#4dd0e1",
        "rmd-cyan-400": "#26c6da",
        "rmd-cyan-500": "#00bcd4",
        "rmd-cyan-600": "#00acc1",
        "rmd-cyan-700": "#0097a7",
        "rmd-cyan-800": "#00838f",
        "rmd-cyan-900": "#006064",
        "rmd-cyan-a-100": "#84ffff",
        "rmd-cyan-a-200": "#18ffff",
        "rmd-cyan-a-400": "#00e5ff",
        "rmd-cyan-a-700": "#00b8d4",
        "rmd-teal-50": "#e0f2f1",
        "rmd-teal-100": "#b2dfdb",
        "rmd-teal-200": "#80cbc4",
        "rmd-teal-300": "#4db6ac",
        "rmd-teal-400": "#26a69a",
        "rmd-teal-500": "#009688",
        "rmd-teal-600": "#00897b",
        "rmd-teal-700": "#00796b",
        "rmd-teal-800": "#00695c",
        "rmd-teal-900": "#004d40",
        "rmd-teal-a-100": "#a7ffeb",
        "rmd-teal-a-200": "#64ffda",
        "rmd-teal-a-400": "#1de9b6",
        "rmd-teal-a-700": "#00bfa5",
        "rmd-green-50": "#e8f5e9",
        "rmd-green-100": "#c8e6c9",
        "rmd-green-200": "#a5d6a7",
        "rmd-green-300": "#81c784",
        "rmd-green-400": "#66bb6a",
        "rmd-green-500": "#4caf50",
        "rmd-green-600": "#43a047",
        "rmd-green-700": "#388e3c",
        "rmd-green-800": "#2e7d32",
        "rmd-green-900": "#1b5e20",
        "rmd-green-a-100": "#b9f6ca",
        "rmd-green-a-200": "#69f0ae",
        "rmd-green-a-400": "#00e676",
        "rmd-green-a-700": "#00c853",
        "rmd-light-green-50": "#f1f8e9",
        "rmd-light-green-100": "#dcedc8",
        "rmd-light-green-200": "#c5e1a5",
        "rmd-light-green-300": "#aed581",
        "rmd-light-green-400": "#9ccc65",
        "rmd-light-green-500": "#8bc34a",
        "rmd-light-green-600": "#7cb342",
        "rmd-light-green-700": "#689f38",
        "rmd-light-green-800": "#558b2f",
        "rmd-light-green-900": "#33691e",
        "rmd-light-green-a-100": "#ccff90",
        "rmd-light-green-a-200": "#b2ff59",
        "rmd-light-green-a-400": "#76ff03",
        "rmd-light-green-a-700": "#64dd17",
        "rmd-lime-50": "#f9fbe7",
        "rmd-lime-100": "#f0f4c3",
        "rmd-lime-200": "#e6ee9c",
        "rmd-lime-300": "#dce775",
        "rmd-lime-400": "#d4e157",
        "rmd-lime-500": "#cddc39",
        "rmd-lime-600": "#c0ca33",
        "rmd-lime-700": "#afb42b",
        "rmd-lime-800": "#9e9d24",
        "rmd-lime-900": "#827717",
        "rmd-lime-a-100": "#f4ff81",
        "rmd-lime-a-200": "#eeff41",
        "rmd-lime-a-400": "#c6ff00",
        "rmd-lime-a-700": "#aeea00",
        "rmd-yellow-50": "#fffde7",
        "rmd-yellow-100": "#fff9c4",
        "rmd-yellow-200": "#fff59d",
        "rmd-yellow-300": "#fff176",
        "rmd-yellow-400": "#ffee58",
        "rmd-yellow-500": "#ffeb3b",
        "rmd-yellow-600": "#fdd835",
        "rmd-yellow-700": "#fbc02d",
        "rmd-yellow-800": "#f9a825",
        "rmd-yellow-900": "#f57f17",
        "rmd-yellow-a-100": "#ffff8d",
        "rmd-yellow-a-200": "#ff0",
        "rmd-yellow-a-400": "#ffea00",
        "rmd-yellow-a-700": "#ffd600",
        "rmd-amber-50": "#fff8e1",
        "rmd-amber-100": "#ffecb3",
        "rmd-amber-200": "#ffe082",
        "rmd-amber-300": "#ffd54f",
        "rmd-amber-400": "#ffca28",
        "rmd-amber-500": "#ffc107",
        "rmd-amber-600": "#ffb300",
        "rmd-amber-700": "#ffa000",
        "rmd-amber-800": "#ff8f00",
        "rmd-amber-900": "#ff6f00",
        "rmd-amber-a-100": "#ffe57f",
        "rmd-amber-a-200": "#ffd740",
        "rmd-amber-a-400": "#ffc400",
        "rmd-amber-a-700": "#ffab00",
        "rmd-orange-50": "#fff3e0",
        "rmd-orange-100": "#fff0b2",
        "rmd-orange-200": "#ffcc80",
        "rmd-orange-300": "#ffb74d",
        "rmd-orange-400": "#ffa726",
        "rmd-orange-500": "#ff9800",
        "rmd-orange-600": "#fb8c00",
        "rmd-orange-700": "#f57c00",
        "rmd-orange-800": "#ef6c00",
        "rmd-orange-900": "#e65100",
        "rmd-orange-a-100": "#ffd180",
        "rmd-orange-a-200": "#ffab40",
        "rmd-orange-a-400": "#ff9100",
        "rmd-orange-a-700": "#ff6d00",
        "rmd-deep-orange-50": "#fbe9e7",
        "rmd-deep-orange-100": "#ffccbc",
        "rmd-deep-orange-200": "#ffab91",
        "rmd-deep-orange-300": "#ff8a65",
        "rmd-deep-orange-400": "#ff7043",
        "rmd-deep-orange-500": "#ff5722",
        "rmd-deep-orange-600": "#f4511e",
        "rmd-deep-orange-700": "#e64a19",
        "rmd-deep-orange-800": "#d84315",
        "rmd-deep-orange-900": "#bf360c",
        "rmd-deep-orange-a-100": "#ff9e80",
        "rmd-deep-orange-a-200": "#ff6e40",
        "rmd-deep-orange-a-400": "#ff3d00",
        "rmd-deep-orange-a-700": "#dd2c00",
        "rmd-brown-50": "#efebe9",
        "rmd-brown-100": "#d7ccc8",
        "rmd-brown-200": "#bcaaa4",
        "rmd-brown-300": "#a1887f",
        "rmd-brown-400": "#8d6e63",
        "rmd-brown-500": "#795548",
        "rmd-brown-600": "#6d4c41",
        "rmd-brown-700": "#5d4037",
        "rmd-brown-800": "#4e342e",
        "rmd-brown-900": "#3e2723",
        "rmd-grey-50": "#fafafa",
        "rmd-grey-100": "#f5f5f5",
        "rmd-grey-200": "#eee",
        "rmd-grey-300": "#e0e0e0",
        "rmd-grey-400": "#bdbdbd",
        "rmd-grey-500": "#9e9e9e",
        "rmd-grey-600": "#757575",
        "rmd-grey-700": "#616161",
        "rmd-grey-800": "#424242",
        "rmd-grey-900": "#212121",
        "rmd-blue-grey-50": "#eceff1",
        "rmd-blue-grey-100": "#cfd8dc",
        "rmd-blue-grey-200": "#b0bec5",
        "rmd-blue-grey-300": "#90a4ae",
        "rmd-blue-grey-400": "#78909c",
        "rmd-blue-grey-500": "#607d8b",
        "rmd-blue-grey-600": "#546e7a",
        "rmd-blue-grey-700": "#455a64",
        "rmd-blue-grey-800": "#37474f",
        "rmd-blue-grey-900": "#263238",
        "rmd-black-base": "#000",
        "rmd-white-base": "#fff",
    },
    "rmd-theme-no-css-variables-fallback": true,
    "rmd-theme-define-colors-with-rgba": true,
    "rmd-theme-light": true,
    "rmd-theme-primary": "#9c27b0",
    "rmd-theme-on-primary": "#fff",
    "rmd-theme-secondary": "#f50057",
    "rmd-theme-on-secondary": "#fff",
    "rmd-theme-warning": "#ff6e40",
    "rmd-theme-on-warning": "#fff",
    "rmd-theme-error": "#f44336",
    "rmd-theme-on-error": "#fff",
    "rmd-theme-success": "#00c853",
    "rmd-theme-on-success": "#000",
    "rmd-theme-light-background": "#fafafa",
    "rmd-theme-light-surface": "#fff",
    "rmd-theme-dark-background": "#303030",
    "rmd-theme-dark-surface": "#424242",
    "rmd-theme-background": "#fafafa",
    "rmd-theme-surface": "#fff",
    "rmd-theme-on-surface": "#000",
    "rmd-theme-light-primary-text-color": "#212121",
    "rmd-theme-light-secondary-text-color": "#757575",
    "rmd-theme-light-hint-text-color": "#a8a8a8",
    "rmd-theme-light-disabled-text-color": "#9e9e9e",
    "rmd-theme-light-icon-color": "#757575",
    "rmd-theme-dark-primary-text-color": "#d9d9d9",
    "rmd-theme-dark-secondary-text-color": "#b3b3b3",
    "rmd-theme-dark-hint-text-color": "gray",
    "rmd-theme-dark-disabled-text-color": "gray",
    "rmd-theme-dark-icon-color": "#b3b3b3",
    "rmd-theme-light-text-colors": {
        primary: "#212121",
        secondary: "#757575",
        hint: "#a8a8a8",
        disabled: "#9e9e9e",
        icon: "#757575",
    },
    "rmd-theme-dark-text-colors": {
        primary: "#d9d9d9",
        secondary: "#b3b3b3",
        hint: "gray",
        disabled: "gray",
        icon: "#b3b3b3",
    },
    "rmd-theme-primary-text-on-background-color": "#212121",
    "rmd-theme-secondary-text-on-background-color": "#757575",
    "rmd-theme-hint-text-on-background-color": "#a8a8a8",
    "rmd-theme-disabled-text-on-background-color": "#9e9e9e",
    "rmd-theme-icon-on-background-color": "#757575",
    "rmd-theme-primary-text-on-light-color": "#212121",
    "rmd-theme-secondary-text-on-light-color": "#757575",
    "rmd-theme-hint-text-on-light-color": "#a8a8a8",
    "rmd-theme-disabled-text-on-light-color": "#9e9e9e",
    "rmd-theme-icon-on-light-color": "#757575",
    "rmd-theme-primary-text-on-dark-color": "#d9d9d9",
    "rmd-theme-secondary-text-on-dark-color": "#b3b3b3",
    "rmd-theme-hint-text-on-dark-color": "gray",
    "rmd-theme-disabled-text-on-dark-color": "gray",
    "rmd-theme-icon-on-dark-color": "#b3b3b3",
    "rmd-theme-values": {
        background: "#fafafa",
        primary: "#9c27b0",
        "on-primary": "#fff",
        secondary: "#f50057",
        "on-secondary": "#fff",
        surface: "#fff",
        "on-surface": "#000",
        warning: "#ff6e40",
        "on-warning": "#fff",
        error: "#f44336",
        "on-error": "#fff",
        success: "#00c853",
        "on-success": "#000",
        "text-primary-on-background": "#212121",
        "text-secondary-on-background": "#757575",
        "text-hint-on-background": "#a8a8a8",
        "text-disabled-on-background": "#9e9e9e",
        "text-icon-on-background": "#757575",
        "light-background": "#fafafa",
        "light-surface": "#fff",
        "dark-background": "#303030",
        "dark-surface": "#424242",
        "text-primary-on-light": "#212121",
        "text-secondary-on-light": "#757575",
        "text-hint-on-light": "#a8a8a8",
        "text-disabled-on-light": "#9e9e9e",
        "text-icon-on-light": "#757575",
        "text-primary-on-dark": "#d9d9d9",
        "text-secondary-on-dark": "#b3b3b3",
        "text-hint-on-dark": "gray",
        "text-disabled-on-dark": "gray",
        "text-icon-on-dark": "#b3b3b3",
    },
};
//# sourceMappingURL=scssVariables.js.map